import React from 'react';
import { Table, Row, Col } from 'react-bootstrap';

// import MaintenanceOrderDetailListViewContainer from '../containers/MaintenanceOrderDetailListViewContainer.jsx';

export default class MaintenanceOrderEditComponent extends React.Component {

	componentDidMount() {
	}

	componentWillMount() {
		// this.props.findMaintenanceOrderDetails(this.props.order.get('orderId'));
	}

	render() {
		// console.log('this.props.order.get()  === '+ this.props.order.get('orderId'));
		// this.props.findMaintenanceOrderDetails(this.props.order.get('orderId'));
		// let morderDetails = this.props.orderDetail.get('details');

		let noteDisply = this.props.order.get('noteDisplay');
		let note = '';
		if (this.props.showNote) {
			note = this.props.order.get('note');
		}

		return (
			<div>
				<Row>
					<Col xs={12} sm={12} md={12}>
						<table className="table table-bordered">
							<tbody>
								<tr>
									<td colSpan="4" style={{ textAlign: 'center' }}><h4>清洗維修 訂 單 審 查 表</h4></td>
								</tr>
								<tr>
									<td colSpan="2">編號:{this.props.order.get('orderId')}</td>
									<td colSpan="2">日期:{this.props.order.get('sOrderDate')}</td>
								</tr>
								<tr>
									<td>客戶名稱</td>
									<td>{this.props.order.get('customerName')} ({this.props.order.get('customerId')})</td>
									<td>訂貨人: {this.props.order.get('caseOfficer')}</td>
									<td>電話: {this.props.order.get('phone')}</td>
								</tr>
								<tr>
									<td>地址</td>
									<td>{this.props.order.get('address')}</td>
									<td>交期: {this.props.order.get('sDueDate')}</td>
									<td>傳真: {this.props.order.get('fax')}</td>
								</tr>
								<tr>
									<td>用途</td>
									<td colSpan="2">{this.props.order.get('caseName')}</td>
									<td>案號: {this.props.order.get('caseNumber')}</td>
								</tr>
							</tbody>
						</table>
					</Col>
				</Row>
				<Row style={{ paddingTop: -20 }}>
					<Col xs={12} sm={12} md={12}>
						{
							<div>
								<Table bordered condensed hover>
									<thead>
										<tr>
											<th>編號</th>
											<th>產品名</th>
											<th>訂購數量</th>
										</tr>
									</thead>
									<tbody>
										{
											this.props.orderDetail.get('details').map((item, index) =>
												<tr key={index}>
													<td>{index + 1}</td>
													<td>{item.category}-{item.checkSet}</td>
													<td>{item.quantity}</td>
												</tr>
											)
										}
									</tbody>
								</Table>
							</div>
						}
						{/*<MaintenanceOrderDetailListViewContainer orderId={this.props.order.get('orderId')} />*/}
					</Col>
				</Row>
				<Row>
					<Col xs={12} sm={12} md={12}>
						<pre style={{ backgroundColor: 'white' }}>
							{noteDisply}
							<br />
							{note}
						</pre>
					</Col>
				</Row>
			</div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/components/MaintenanceOrderViewComponent.jsx